// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'production',
  production: true,
  staging: false,
  DATE_FORMAT: 'dd/MM/yyyy',
  DATE_TIME_FORMAT: 'MM/dd/yyyy HH:mm:ss',
  VDATE_TIME_FORMAT: 'dd.MM.yyyy HH:mm:ss',
  AG_DATE_FORMAT: 'DD.MM.yyyy',
  AG_DATE_TIME_FORMAT: 'MM/DD/yyyy HH:mm:ss',
  USERAPIENDPOINT: 'https://api.ltytech.ch/api/ims/v1/',
  COMMUNICATORAPIURL: 'https://api.ltytech.ch/api/communicator/v1/',
  DOCUMENTAPIURL: 'https://api.ltytech.ch/api/document-store/v1/',
  INSURANCEAPIURL: 'https://api.ltytech.ch/api/insurance/v1/',
  CATALOGUEAPIURL: 'https://api.ltytech.ch/api/catalogue/v1/',
  FEEAPIENDPOINT: 'https://api.ltytech.ch/api/fee/v1/',
  ROLEAPIENDPOINT: 'https://api.ltytech.ch/api/role-access/v1/',
  // FILEPATHPOINT:"http://44.203.193.10/backend/uploads/",
  tokenValidityTimeMinutes: 60,
  BASE_URL: 'https://api.ltytech.ch/',

  PARTNER_APP_URL: 'https://gestion.lty.ch',
  PARTNER_APP_FLOW_PATH: 'proposal/flow',
  PARTNER_APP_CUSTOMER_PATH: 'customer/view/user',
  PARTNER_APP_CUSTOMER_MEMBER_PATH: 'customer/view/member',
  VERSION: '1.0.14',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
